// This handles the did you know buttons

import {gsap} from 'gsap';

(function() {

	const button = document.getElementById('DidYouKnowBtn');
	const close = document.getElementById('Close');

	if(button) {

		const spans = button.getElementsByTagName('span');

		const tl = gsap.timeline({paused: true});
		let isOpen = false;

		tl.to(spans, {
			backgroundColor: '#8B3BE3',
			duration: 0.25
		}, 0);

		tl.to('.fact-container', {
			scaleX: 1,
			scaleY: 1,
			ease: 'circ.inOut',
			duration: 0.5
		}, 0);

		tl.to('.inner-fact-container', {
			opacity: 1,
			paddingTop: 60,
			paddingBottom: 60,
			duration: 0.25
		});

		button.addEventListener('click', () => {

			if(!isOpen) {
				tl.play();
			} else {
				tl.reverse();
				fetchFact();
			}

			isOpen = !isOpen;

		});

		close.addEventListener('click', () => {
			tl.reverse();
			fetchFact();
			isOpen = !isOpen;
		});

		function fetchFact() {

			const FactContainer = document.getElementById('Fact');

			jQuery.ajax({
				method: 'POST',
				// eslint-disable-next-line no-undef
				url: ajax_object.ajax_url,
				data: {
					action: 'get_fact',
				},
				success(resp) {
					FactContainer.textContent = resp.html;
				},
				error(err) {
					console.log(err);
				}
			});

		}

	}

}());
